import React, { useState } from 'react';
import Display from './Display';
import DemoRequest from './DemoRequest';
import NavBarMain from './NavBarMain';
import Cookies from 'js-cookie';

const RootPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    courseInterest: '',
    studentLevel: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const cookie1 = Cookies.get('mycookie1');
  const cookie2 = Cookies.get('mycookie2');
const cookie3 = Cookies.get('mycookie3'); 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, you would send this data to your backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
  };

  return (
    <>
   {/* <h1>{cookie1}{cookie2}/{cookie3}</h1> */}
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-indigo-100">
  
      {/* <Display/> */}
      {/* Navigation
      <nav className="bg-white shadow-lg">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <div className="bg-indigo-600 text-white p-2 rounded-lg mr-2">
                <i className="fas fa-graduation-cap text-xl"></i>
              </div>
              <span className="text-2xl font-bold text-indigo-600">MATRIXLERN</span>
            </div>
            
            <div className="hidden md:flex space-x-8">
              <a href="#" className="text-indigo-600 font-medium">Home</a>
              <a href="#" className="text-gray-600 hover:text-indigo-600">Courses</a>
              <a href="#" className="text-gray-600 hover:text-indigo-600">Tutors</a>
              <a href="#" className="text-gray-600 hover:text-indigo-600">Pricing</a>
              <a href="#" className="text-gray-600 hover:text-indigo-600">About</a>
            </div>
            
            <div className="flex items-center">
              <button className="hidden md:block text-indigo-600 font-medium mr-4">Login</button>
              <button className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition">Sign Up</button>
            </div>
          </div>
        </div>
      </nav> */}

      {/* Hero Section */}
      <section className="py-5 md:py-5">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight mb-4">
                Learn Without <span className="text-indigo-600">Limits</span> with Personalized Online Tutoring
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                Connect with expert tutors in 50+ subjects. Our AI-powered platform matches you with the perfect tutor for your learning style and goals.
              </p>
              <div className="flex flex-wrap gap-4">
                <button className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-700 transition">
                  Start Learning Now
                </button>
                <button className="border border-indigo-600 text-indigo-600 px-6 py-3 rounded-lg font-medium hover:bg-indigo-50 transition">
                  <i className="fas fa-play-circle mr-2"></i>Watch Demo
                </button>
              </div>
              <div className="mt-8 flex items-center">
                <div className="flex -space-x-3 mr-4">
                  <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Student" className="w-10 h-10 rounded-full border-2 border-white" />
                  <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Student" className="w-10 h-10 rounded-full border-2 border-white" />
                  <img src="https://randomuser.me/api/portraits/women/45.jpg" alt="Student" className="w-10 h-10 rounded-full border-2 border-white" />
                </div>
                <p className="text-gray-600">
                  <span className="font-semibold text-indigo-600">5,000+</span> students learning with us
                </p>
              </div>
            </div>
            <div className="md:w-1/2">
              <DemoRequest/>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Why Choose MATRIXLERN?</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Our innovative approach to online education sets us apart from traditional tutoring services.</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6 rounded-lg hover:shadow-lg transition">
              <div className="bg-indigo-100 text-indigo-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-user-check text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Expert Tutors</h3>
              <p className="text-gray-600">Our tutors are subject matter experts with proven teaching experience and rigorous screening.</p>
            </div>
            
            <div className="text-center p-6 rounded-lg hover:shadow-lg transition">
              <div className="bg-green-100 text-green-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-brain text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">AI-Powered Matching</h3>
              <p className="text-gray-600">Our algorithm matches you with the perfect tutor based on your learning style and goals.</p>
            </div>
            
            <div className="text-center p-6 rounded-lg hover:shadow-lg transition">
              <div className="bg-purple-100 text-purple-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-chart-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Progress Tracking</h3>
              <p className="text-gray-600">Monitor your learning journey with detailed analytics and personalized progress reports.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 bg-indigo-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">What Our Students Say</h2>
            <p className="text-lg text-gray-600">Hear from students who have transformed their learning with MATRIXLERN.</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow">
              <div className="flex items-center mb-4">
                <div className="text-yellow-400 mr-2">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
                <span className="text-gray-600">5.0</span>
              </div>
              <p className="text-gray-600 mb-4">"My math grades improved from C to A in just 3 months. The personalized attention made all the difference!"</p>
              <div className="flex items-center">
                <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Student" className="w-12 h-12 rounded-full mr-4" />
                <div>
                  <h4 className="font-semibold text-gray-800">Sarah Johnson</h4>
                  <p className="text-gray-600">Grade 10 Student</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow">
              <div className="flex items-center mb-4">
                <div className="text-yellow-400 mr-2">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
                <span className="text-gray-600">5.0</span>
              </div>
              <p className="text-gray-600 mb-4">"The programming courses are fantastic! I landed my first developer job after completing the full-stack web development track."</p>
              <div className="flex items-center">
                <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Student" className="w-12 h-12 rounded-full mr-4" />
                <div>
                  <h4 className="font-semibold text-gray-800">Michael Chen</h4>
                  <p className="text-gray-600">Adult Learner</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow">
              <div className="flex items-center mb-4">
                <div className="text-yellow-400 mr-2">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star-half-alt"></i>
                </div>
                <span className="text-gray-600">4.5</span>
              </div>
              <p className="text-gray-600 mb-4">"The chemistry tutor helped my daughter finally understand complex concepts. She's now confident and excited about science!"</p>
              <div className="flex items-center">
                <img src="https://randomuser.me/api/portraits/women/45.jpg" alt="Parent" className="w-12 h-12 rounded-full mr-4" />
                <div>
                  <h4 className="font-semibold text-gray-800">Lisa Rodriguez</h4>
                  <p className="text-gray-600">Parent</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-indigo-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Transform Your Learning Journey?</h2>
          <p className="text-lg mb-8 max-w-2xl mx-auto">Join thousands of students who have achieved academic success with MATRIXLERN's personalized tutoring approach.</p>
          <button className="bg-white text-indigo-600 px-8 py-3 rounded-lg font-semibold hover:bg-indigo-50 transition">
            Get Started Today
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="bg-indigo-600 text-white p-2 rounded-lg mr-2">
                  <i className="fas fa-graduation-cap"></i>
                </div>
                <span className="text-xl font-bold">MATRIXLERN</span>
              </div>
              <p className="text-gray-400">Transforming education through personalized online tutoring.</p>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-400 hover:text-white">About Us</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white">Courses</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white">Become a Tutor</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white">Blog</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4">Support</h3>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-400 hover:text-white">FAQ</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white">Contact Us</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white">Privacy Policy</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white">Terms of Service</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4">Connect With Us</h3>
              <div className="flex space-x-4 mb-4">
                <a href="#" className="bg-gray-700 w-10 h-10 rounded-full flex items-center justify-center hover:bg-indigo-600">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" className="bg-gray-700 w-10 h-10 rounded-full flex items-center justify-center hover:bg-indigo-600">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#" className="bg-gray-700 w-10 h-10 rounded-full flex items-center justify-center hover:bg-indigo-600">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#" className="bg-gray-700 w-10 h-10 rounded-full flex items-center justify-center hover:bg-indigo-600">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
              <p className="text-gray-400">Subscribe to our newsletter</p>
              <div className="mt-2 flex">
                <input type="email" placeholder="Your email" className="bg-gray-700 text-white px-4 py-2 rounded-l-lg focus:outline-none w-full" />
                <button className="bg-indigo-600 px-4 py-2 rounded-r-lg hover:bg-indigo-700">
                  <i className="fas fa-paper-plane"></i>
                </button>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>© 2023 MATRIXLERN Online Tuition App. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default RootPage;